/**
 * SIRH ACTION
 */

export const integrationFetchLuccaOptions = () => ({
  type : 'API',
  payload : {
    method : "GET",
    url : "/integration/lucca/options"
  }
})

export const integrationFetchLuccaUsers = () => ({
  type : 'API',
  payload : {
    method : "GET",
    url : "/integration/lucca/users"
  }
})

//Initial sync of the users from the Entra ID directory (Cryptr)
//Preview (dryRun: counts only) then import of the Entra ID directory, done by the backend
export const integrationImportEntra = (dryRun: boolean, isManagerAccess: boolean) => ({
  type : 'API',
  payload : {
    method : "POST",
    url : "/integration/entra/import",
    data : { dryRun, isManagerAccess }
  }
})

export const integrationFetchMondayDeals_AsSupervisor = () => ({
  type : 'API',
  payload : {
    method : "GET",
    url : "/supervisor/integration/monday/deals"
  }
})

//Ignore a Monday deal (hidden from the accounts board) or show it again
export const integrationIgnoreMondayDeal_AsSupervisor = (dealId: string, isIgnored: boolean) => ({
  type : 'API',
  payload : {
    method : "POST",
    url : "/supervisor/integration/monday/deal/ignore",
    data : {
      dealId,
      isIgnored
    }
  }
})
